import React from "react";
import "./Hero.css";

const Hero: React.FC = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero-banner">
        <img src="/header.jpg" alt="Open book" className="banner-image" />
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <img src="/logo.png" alt="Spark Enrichment Logo" className="hero-center-logo" />
          <p className="hero-subtitle">
            Personalized Academic Support from Pre-K through College
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
